var createReactClass = require('create-react-class');
import React from 'react';

const Author = createReactClass({
  render: function(){
    return (
      <div className="columns small-6 featured-user" >
        <div className="small-2 columns featured-user-checkbox-container">
          <input type="checkbox" name={this.props.author.id} onClick={this.props.handleSelect}/>
        </div>
        <div className="small-10 columns user-info" >
          <div className="row">
            <div className="medium-2 columns avatar-container">
              <div className="avatar">
                <img src={this.props.author.avatar_profile_url} />
              </div>
            </div>
            <div className="medium-10 columns user-info-container">
              <div className="title">
                <strong className="full-name">
                  {this.props.author.full_name}  
                </strong>
                {this.props.author.qualification_titles}
              </div>

              <div className="specialty">
                {this.props.author.specialty}
              </div>

              <div className="row affiliation">
                <div className="columns icon-container small-1">
                  <i className="far fa-building"></i>
                </div>
                <div className="columns affiliation-name small-11">
                  <span>{this.props.author.affiliation_name_full}</span>
                </div>
              </div>

            </div>

          </div>
        </div>
      </div>
    )
  }
})

export default Author;
